export default [
    {
        path: '/admin/bronameth',
        exact: true,
        component: 'AdminLogin'
    }
]